import React from "react";
import s from "./CommentModal.less";
import Modal from "~/shared/ui/Fields/Modal";
import TextArea from "~/shared/ui/Fields/TextArea";
import Button from "~/shared/ui/Fields/Button";
import { useForm } from "react-hook-form/dist/index.ie11";
import { useTranslation } from "react-i18next";

const CommentModal = ({ isOpen, onClose, onSubmit }) => {
  const { handleSubmit, control } = useForm();
  const { t } = useTranslation();

  const handleFormSubmit = handleSubmit((data) => {
    onSubmit(data.description);
    onClose();
  });

  return (
    <Modal
      isOpen={isOpen}
      title={t("ui.reasonRejection")}
      actionClose={onClose}
    >
      <div className={s.block_wrapper}>
        <TextArea
          name="description"
          control={control}
          vertical
          placeholder={t("ui.enterComment")}
        />
        <Button
          orange
          txtBtn={t("ui.send")}
          onClick={handleFormSubmit}
          customClassName={s.btn}
        />
      </div>
    </Modal>
  );
};
export default CommentModal;
